import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-container" style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '2rem'
    }}>
      <style>
        {`
          .spinner {
            width: 40px;
            height: 40px;
            border: 3px solid rgba(44, 90, 160, 0.1);
            border-radius: 50%;
            border-top-color: #2c5aa0;
            animation: spin 1s ease-in-out infinite;
          }
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="spinner" aria-label="Loading content..."></div>
    </div>
  );
};

export default LoadingSpinner;
